(function () {
/*
    This module covers dynamic data updates on the header which includes
    user login status, basket and adding listeners for TN page
    Get basket data from local storage
    Fetch running total
    Update dynamic data
  */

  RS.Modules.UserStatus = {

    refLogInOut: null,
    refRegister: null,
    refWelcome: null,
    refNotYou: null,
    refSecondaryNavList: null,
    refCredit: null,
    refMyAccountMenuList: null,
    refBasketContainer: null,
    refBasketQty: null,
    refBasketLink: null,
    refBasketAmt: null,
    refPhone: null,
    pollingFrequency: 5000,
    timeoutID: null,
    isNewHeader: null,
    isNewFooter: null,

    init: function () {
      this.refLogInOut = $('#js-logInOut');
      this.refRegister = $('#js-register');
      this.refWelcome = $('#js-welcome');
      this.refNotYou = $('#js-notYou');
      this.refSecondaryNavList = $('#js-secondaryNav');
      this.refCredit = $('#js-myAccount > li:last-child');
      this.refMyAccountMenuList = $('#js-myAccount');
      this.refBasketContainer = $('.js-basket');
      this.refBasketQty = $('#js-basketQty');
      this.refBasketLink = $('.js-basket a');
      this.refBasketAmt = $('#js-basketAmt');
      this.refPhone = $('.phone');
      this.isNewHeader = $('header');
      this.isNewFooter = $('footer');
      this.updateBasket();
      this.runningTotal();
      this.dynamicData();
      this.basketListener();
    },

    checkLogStatus: function(){
      var _logStatus = RS.Utils.Cookies.getCookie('loginStatus');
      return ($.isNumeric(_logStatus));
    },

    updateBasket: function () {
      var _cartId = RS.Utils.Cookies.getCookie('cart');
      var _basket;
      try {
        _basket = JSON.parse(RS.Utils.LocalStorage.getItem('minibasket'));
      } catch (e) {
        _basket = null;
      }
      if (_cartId != null && _basket != null) {
        this.refBasketQty.text(_basket.prdqty);
        this.refBasketAmt.text(_basket.totalamt);
      }
    },

    runningTotal: function () {
      var _url = '/web/miniBasketRunningTotal.html';
      var _type = 'GET';
      RS.Utils.AjaxService.processXHR(_url, _type, 5000, RS.Modules.UserStatus.updateRunningTotal);
    },

    updateRunningTotal: function (data) {
      var _basket = data.split('||');
      var objUS = RS.Modules.UserStatus;
      if (_basket != null && _basket[0] === 'stable') {
        // update QTY, Amount and Title
        objUS.refBasketQty.text(_basket[1]);
        objUS.refBasketAmt.text(_basket[2]);
        objUS.updateTitle(_basket[1]);
        // only when there are items
        objUS.refBasketContainer.attr('data-loggedin', (_basket[1] > 0));
        // store data
        objUS.lsStorage(_basket[1], _basket[2]);
        // clear timeout
        if (objUS.timeoutID != null) {
          window.clearTimeout(objUS.timeoutID);
          delete objUS.timeoutID;
        }
      } else {
        if (_basket[0] === 'unstable') {
          // keep polling until stable
          objUS.timeoutID = window.setTimeout(objUS.runningTotal, objUS.pollingFrequency);
        }
      }
    },

    /*Update the basket title on the page */
    updateTitle: function (items) {
      var titleText;
      // check that page has basket title var
      if (typeof BasketTitle !== 'undefined') {
        if (items > 0) {
          titleText = items + ' ' + BasketTitle.hasitems;
        } else {
          titleText = BasketTitle.empty;
        }
        RS.Modules.UserStatus.refBasketLink.attr('title', titleText);
      }
    },

    lsStorage: function (qty, amt) {
      var _basketData = {
        cartid: RS.Utils.Cookies.getCookie('cart'),
        prdqty: qty,
        totalamt: amt,
        lastupd: new Date().getTime(),
      };
      RS.Utils.LocalStorage.setItem('minibasket', JSON.stringify(_basketData));
    },

    dynamicData: function () {
      // only if loginStatus is available
      if(!this.checkLogStatus())
        return;
      var _url = '/web/services/header/getDynamicData';
      var _type = 'GET';
      RS.Utils.AjaxService.processXHR(_url, _type, 5000, this.updateDynamicData);
    },

    updateDynamicData: function (data) {
      var objUS = RS.Modules.UserStatus;
      // Remove credit account if set to not display
      if (data.credAccount) {
          objUS.refCredit.toggle(data.credAccount.display);
      }
      // Update logged in
      if (data.loggedInfo && data.loggedInfo.loggedIn) {
        objUS.refLogInOut.text(data.loggedInfo.logoutLabel)
          .attr('title', data.loggedInfo.logoutLabel)
          .attr('href', data.loggedInfo.logoutLink);

        objUS.refMyAccountMenuList.append($('<li class="logStatus"><a href="' +
          data.loggedInfo.logoutLink + '" class="btn">' +
          data.loggedInfo.logoutLabel + '</a></li>'));
      }
      // Update 'remember me' text
      if (objUS.isNewHeader.length > 0 &&
        data.rememberMe && data.rememberMe.selected) {
        objUS.refNotYou.html('<a href="' + data.rememberMe.notMeLink + '">' +
          data.rememberMe.notMeLabel + '</a>').show();
      }
      // Update Name
      if (data.names) {
        objUS.refRegister.hide();
        if (objUS.isNewHeader.length > 0) {
          objUS.refWelcome.text(data.names.greeting + ' ' + data.names.foreName).show();
        }
      }
      // Update details for PM user
      if (data.userType === 'PM' && data.pmUser.enabled) {
        objUS.updatePMDtls(objUS, data);
      }
      //Update details for PUNCH_OUT user
      if (data.userType === 'PUNCH_OUT' && data.names) {
        objUS.refLogInOut.hide();
        objUS.refWelcome.text(data.names.greeting + ' ' + (data.names.eprocDisplayName ? data.names.eprocDisplayName : '')).show();
      }
    },

    updatePMDtls: function (objUS, data) {
      // Add additional link for PM user in header if not present
      if (objUS.refSecondaryNavList.length > 0 && objUS.refSecondaryNavList.find('a[href="' + data.pmUser.link + '"]').length == 0 ) {
        objUS.refSecondaryNavList.append($('<li></li>')
          .html($('<a></a>')
            .attr('href', data.pmUser.link)
            .text(data.pmUser.label)));
      }

      // Update phone number in footer
      if (objUS.refPhone.length > 0) {
        objUS.refPhone.text(data.pmUser.helpline);
      }
    },

    basketListener: function () {
      // Listen for the reloadMiniBasket custom event sent by Angular, when its received, hide #js-basketAmt  & then call getRunningTotal to update the totals
      this.refBasketQty.on('reloadMiniBasket', function () {
        setTimeout(RS.Modules.UserStatus.runningTotal, RS.Modules.UserStatus.pollingFrequency);
      });
      this.refBasketQty.on('reloadMiniBasketAndSendToAnalytics', function (event) {
        setTimeout(RS.Modules.UserStatus.runningTotal, RS.Modules.UserStatus.pollingFrequency);
        RS.Modules.Analytics.publishAddToCartEvent(event.detail.rsStockNumber,
          event.detail.quantity, event.detail.pageName);
      });
    },

  };
}());

(function () {
  RS.Modules.UserStatus.init();
}());



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/universalheader/userstatus.js
// module id = 322
// module chunks = 5